module.exports = __webpack_public_path__ + "img/angrybanker-background.c447780a.png";